/**
 *
 * @author Vašek Brychta <mail@vasekbrychta.cz>
 * @version 2015-10-17
 */

(function (window, $, Foundation, undefined) {

	if (typeof $ !== 'function') {
		return console.error('brko.countdown.js: jQuery is missing, load it please');
	}

	var countdown = function () {
		var inner = {
			offset: 0,
			determineTimeOffset: function () {
				var t0 = (new Date()).valueOf();
				$.ajax({
						   url: $('body').data('base-path') + '/ntp/',
						   success: function (serverTime, text, resp) {
							   var t1 = serverTime;
							   var t2 = serverTime;
							   var t3 = (new Date()).valueOf();

							   inner.offset = ((t1 - t0) + (t2 - t3)) / 2;
							   var roundTripDelay = (t3 - t0) - (t2 - t1);

							   console.log("NTP delay:", roundTripDelay, "NTP offset:", inner.offset, "client: ", new Date(), "corrected: ", (new Date(t3 + inner.offset)));

							   inner.initializeCountdowns();
						   }
					   });
			},
			initializeCountdowns: function () {
				$('span[data-countdown]').each(function () {
					var rawFinalDate = $(this).data('countdown');
					var finalMillis = (new Date(rawFinalDate)).valueOf() - inner.offset;

					var nowMillis = (new Date()).valueOf();
					if (nowMillis < finalMillis) {
						$("#" + $(this).data('countdown-id')).show();
					}

					var hideElement = $("#" + $(this).data('hide-id'));
					if (!$(hideElement).hasClass('hide')) {
						$(hideElement).hide();
					}

					$(this).countdown(new Date(finalMillis))
						.on('update.countdown', function (event) {
							$(this).html(event.strftime('%M:%S'));
						})
						.on('finish.countdown', function (event) {
							$(this).parent().html($(this).data('finished-text'));
							$("#" + $(this).data('countdown-id')).hide();
							$("#" + $(this).data('hide-id')).show();
							if ($(this).data('hide-imgs')) {
								$("img", "#actual-text-container").each(function () {
									var replacement = document.createElement('div');
									replacement.className += 'forbidden-img';
									replacement.innerHTML = '<i class="fa fa-ban fa-5x" />';
									replacement.style.width = this.offsetWidth + 'px';
									replacement.style.height = this.offsetHeight + 'px';

									this.parentNode.replaceChild(replacement, this);
								});
							}
						});
				});
			}
		};

		this.init = function () {
			inner.determineTimeOffset();
		};
	};

	if (window.brko === undefined) {
		window.brko = new (function () {
		});
	}

	window.brko.countdown = new countdown();

})(window, window.jQuery, window.Foundation);
